import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

export default function TestimonialsSection() {
  const { t } = useLanguage();

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-32 bg-[#0B0A08] noise-overlay">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-[#D4AF37]">
            {t.testimonials.badge}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-white mt-3">
            {t.testimonials.title}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.testimonials.items.map((item, i) => (
            <motion.div
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="group relative bg-[#141311]/80 backdrop-blur-sm border border-white/5 rounded-2xl p-6 hover:border-[#D4AF37]/30 transition-all duration-500"
            >
              <Quote className="w-8 h-8 text-[#D4AF37]/20 mb-4" />
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: item.rating }).map((_, j) => (
                  <Star key={j} className="w-3.5 h-3.5 fill-[#D4AF37] text-[#D4AF37]" />
                ))}
              </div>
              <p className="text-sm text-[#D1D0CC] leading-relaxed mb-5">"{item.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-[#BF953F] to-[#B38728] flex items-center justify-center text-black text-xs font-bold">
                  {item.name.charAt(0)}
                </div>
                <p className="text-sm font-semibold text-white">{item.name}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
